import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Check, Cross, CameraAdd } from 'sushiweb/Icons';
import { Button } from '../../../../UiKit';

export default class ImageValidationOptions extends Component {
  render() {
    const { handoverData } = this.props;
    return (
      <React.Fragment>
        {!handoverData ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <ImageValidationOptionsComp {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

class ImageValidationOptionsComp extends React.Component {
  render() {
    const { handoverData, openTagDetails } = this.props;
    const { show_escalate, actions, is_fraud_concern_view } = handoverData;

    return (
      <div className={`staticText ${is_fraud_concern_view ? 'col' : 'row'}`}>
        {actions &&
          actions.map((item, index) => {
            let Icon = Check;
            if (item.btn.type === 'request_image') {
              Icon = CameraAdd;
            } else if (item.btn.type === 'REJECT') {
              Icon = Cross;
            }
            if (item && item.static_text && !item.static_text.length)
              return null;
            return (
              <div key={index} className='box col iconMarginR'>
                <div className='col boxDetail'>
                  <div className='col'>
                    <p className='titleHeading dark'>
                      {item.static_text_header}
                    </p>
                    <ul>
                      {item &&
                        item.static_text.map((text, index) => (
                          <li key={index}>
                            <p>
                              <span className='iconMarginR'>
                                {item.btn.type === 'approve' ? (
                                  <Check size={14} color={item.btn.btn_color} />
                                ) : (
                                  <Cross size={14} color={item.btn.btn_color} />
                                )}
                              </span>
                              {text}
                            </p>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div className='iconMarginR pt20'>
                    {!show_escalate && item.btn.type === 'escalate' ? null : (
                      <Button
                        title={
                          <p style={{ color: item.btn.btn_color }}>
                            <span className='iconMarginR'>
                              <Icon size={14} color={item.btn.btn_color} />
                            </span>
                            <span>{item.btn.btn_text}</span>
                          </p>
                        }
                        size='compressed'
                        color={item.btn.btn_color}
                        onClick={openTagDetails.bind(this, item.btn)}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}
